import { useMutation, UseMutationOptions } from "react-query";
import { MorningAuthConnectRequestPayload } from "@vy/api-definition";
import { getPrivateApi } from "../../../../services/api";

export function useMorningConnect(
  options?: UseMutationOptions<void, unknown, MorningAuthConnectRequestPayload>,
) {
  return useMutation(async (morningConnectRequest) => {
    const api = getPrivateApi();

    return api.morningConnect({ morningConnectRequest });
  }, options);
}